import { lazy } from 'react';
import { AppPaths } from '@core/routes/routesPaths';
import { actionInterceptor } from '@core/store/middleware/actionsInterceptorMiddleware';
import { AppInit, ConsentManager } from '@hwm/ui-lib';
import { styleConstants } from '@styles/constants';
import store from './core/store/store';
import { environment } from './environment';
import theme from './styles/theme';
import { UnitsChange } from '@shared/components';
import { SiderKeys } from '@shared/components/Sider/Sidebar.utils';
import UserDetails from '@shared/components/UserDetails';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { Provider } from 'react-redux';
import { userProfileReducer } from '@core/store/library-stores';
import { Trans } from '@lingui/macro';

const LazyLayout = lazy(() => import('@shared/components/Layout/AppLayout'));
const consentTexts = {
  banner: {
    description: (
      <Trans>
        We use cookies to improve your experience. You can accept all cookies, reject non-essential cookies, or manage
        your preferences.
      </Trans>
    ),
    acceptAll: <Trans>Accept All</Trans>,
    rejectAll: <Trans>Reject All</Trans>,
    preferences: <Trans>Preferences</Trans>,
  },
  modal: {
    title: <Trans>Cookie Preferences</Trans>,
    analyticsLabel: <Trans>Analytics (Microsoft Clarity)</Trans>,
    analyticsDescription: (
      <Trans>
        Allows us to understand how visitors use our site to improve UX. No personal data is sold or shared outside our
        organization.
      </Trans>
    ),
    save: <Trans>Save Preferences</Trans>,
    cancel: <Trans>Cancel</Trans>,
  },
};

export const AppComponent: React.FC = () => {
  return (
    <I18nProvider i18n={i18n as any} forceRenderOnLocaleChange={false}>
      <ConsentManager clarityId={environment.clarityId} texts={consentTexts}>
      <Provider store={store}>
        {AppInit({
          LazyLayout: LazyLayout,
          actionInterceptor: actionInterceptor as any,
          applicationPaths: AppPaths,
          styleConstants: styleConstants,
          theme: theme,
          additionalConfig: {
            authority: environment.authority,
            clientId: environment.clientId,
            scope: environment.scope,
            silentLoginTimeout: environment.silentLoginTimeout,
          },
          initialLayoutProps: {
            appName: ['Press', 'View'],
            customButtons: [<UnitsChange />, <UserDetails />],
            links: [],
            className: '',
            sidebarState: true,
            sidebarSection: SiderKeys.accHierarchy,
            sessionConfig: {
              sessionCookieDomain: environment.sessionCookieDomain,
              sessionCookieIsSecure: environment.sessionCookieSecure,
              sessionIdleTimeout: environment.sessionCookieIdleTimeout,
            },
          },
          redirectEmptyUrl: AppPaths.pressView.path.base,
          setOidcUser: (d) => store.dispatch(userProfileReducer.slice.actions.setOidcUser(d)),
        })}
      </Provider>
      </ConsentManager>
    </I18nProvider>
  );
};
